import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { COMPANY } from "../data/content";

const Block = ({ title, children }) => (
  <Reveal className="py-10 border-t border-ink/10">
    <h2 className="t-h3 text-coal mb-6">{title}</h2>
    <div className="text-[15px] text-graphite leading-relaxed max-w-2xl space-y-4">{children}</div>
  </Reveal>
);

const Legal = () => (
  <>
    <SEO title="Legal Notice & Privacy | ARCH EXPO" description="Legal notice and privacy policy of ARCH EXPO (Arch Expo AG), Cham, Switzerland." />
    <PageHero label="Legal" titleLines={["Legal notice", "& privacy."]} />
    <section className="bg-paper pb-24 sm:pb-32" data-testid="legal-content">
      <div className="container-ax">
        <Block title="Legal Notice">
          <p>
            <strong className="text-coal">{COMPANY.name}</strong>
          </p>
          <p>Legal form: Aktiengesellschaft (AG)</p>
          <p>Contact: <a href={`mailto:${COMPANY.email}`} className="text-cobalt hover:underline">{COMPANY.email}</a></p>
        </Block>
        <Block title="Privacy Policy">
          <p>
            Arch Expo AG processes personal data only to the extent necessary to respond to enquiries, prepare proposals and fulfil contractual obligations. We do not sell or share personal data with third parties for marketing purposes.
          </p>
          <p>
            <strong className="text-coal">Data you provide.</strong> When you submit an enquiry, we process the details you provide (name, contact information, project details and any attached documents) solely to handle your request.
          </p>
          <p>
            <strong className="text-coal">Storage.</strong> Enquiry data is stored securely and retained only as long as required for the purpose for which it was collected, or as required by Swiss law.
          </p>
          <p>
            <strong className="text-coal">Your rights.</strong> Under the Swiss Federal Act on Data Protection (nFADP), you may request access, correction or deletion of your personal data at any time by contacting us at {COMPANY.email}.
          </p>
        </Block>
        <Block title="Cookies & Analytics">
          <p>
            This website does not use tracking cookies. Should analytics be introduced in future, this policy will be updated and consent requested where required.
          </p>
        </Block>
        <Block title="Intellectual Property">
          <p>
            All content on this website — including text, imagery and graphic elements — is the property of Arch Expo AG or its licensors and may not be reproduced without written permission. Project imagery marked as placeholder is used for layout demonstration only.
          </p>
        </Block>
      </div>
    </section>
  </>
);

export default Legal;
